import React from 'react';

import { ChevronsDown, ChevronsUp } from 'lucide-react';

import { InfoTooltip } from '../../common/InfoTooltip';

const BUTTON_SIZE = 20;

const s = {
  overlay: 'absolute right-4 z-20 flex items-center pointer-events-none',
  collapsedRail: 'relative z-20 flex h-5 shrink-0 items-center justify-end pr-4',
  collapsedLine: 'absolute inset-x-0 top-1/2 -translate-y-1/2 h-[3px] bg-[#e6e8ec]',
  button:
    'pointer-events-auto relative flex h-5 w-5 items-center justify-center rounded-full border-0 p-0 ' +
    'bg-[#0064b0] text-white cursor-pointer ring-2 ring-white transition-colors ' +
    'hover:bg-[#0053a0] focus-visible:bg-[#0053a0]',
  chevron: 'h-3.5 w-3.5',
} as const;

interface NetworkMapSplitHandleProps {
  /** Whether the network map pane is currently showing. */
  isGridExpanded: boolean;
  splitPercentage: number;
  onToggle: () => void;
}

/**
 * Show/hide control for the network map, mounted on the splitter itself
 */
export function NetworkMapSplitHandle({ isGridExpanded, splitPercentage, onToggle }: NetworkMapSplitHandleProps) {
  const label = isGridExpanded ? 'Hide network map' : 'Show network map';
  const Chevron = isGridExpanded ? ChevronsUp : ChevronsDown;

  const button = (
    <InfoTooltip label={label} position="bottom">
      <button type="button" aria-label={label} onClick={onToggle} className={s.button}>
        <Chevron className={s.chevron} strokeWidth={2.75} />
      </button>
    </InfoTooltip>
  );
  if (!isGridExpanded) {
    return (
      <div className={s.collapsedRail}>
        <span className={s.collapsedLine} />
        {button}
      </div>
    );
  }

  return (
    <div className={s.overlay} style={{ top: `calc(${splitPercentage}% - ${BUTTON_SIZE / 2}px)` }}>
      {button}
    </div>
  );
}
